import { Container, Row, Col, Card } from "react-bootstrap";

function Contacto() {
  return (
    <Container className="mt-5">
      {/* Señal de carga completa para el pre-renderizador (para páginas estáticas) */}
      <div id="snap-ready" style={{ display: "none" }}></div>

      <h2 className="text-center mb-4">Contáctanos</h2>
      <Row className="justify-content-center">
        <Col md={6}>
          <Card className="text-center p-4 shadow-sm">
            <Card.Body>
              <h4>¿Tienes alguna duda?</h4>
              <p className="mt-3">Estamos aquí para ayudarte con tu pedido.</p>
              <p>
                <strong>WhatsApp:</strong> +593 99 468 3079
              </p>
              <p><strong>Ubicación:</strong> Quito - Ecuador</p>
              <p>
                <strong>Email:</strong> orozco.pancho73@hotmail.com
              </p>
              <p>
                <strong>Horario:</strong> Lunes a Domingos, abierto 24 horas
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Contacto;
